import {
  Dialog,
  Box,
  Text,
  Icon,
  useBreakpointValue,
  Image,
  HStack,
} from "@chakra-ui/react";
import React from "react";
import { FaFilePdf } from "react-icons/fa";

export const ImagePreview = ({ src, type, label }) => {
  const dialogSize = useBreakpointValue({ base: "xs", md: "lg" });
  const previewUrl = src ? URL.createObjectURL(src) : null;
  const isPdf = src?.type === "application/pdf";
  const isMobile = useBreakpointValue({ base: true, md: true, lg: false });

  return (
    <Dialog.Root size={dialogSize}>
      <Dialog.Trigger asChild>
        {isPdf ? (
          <Box
            cursor="pointer"
            border="1px solid gray"
            padding="1rem"
            borderRadius="md"
            textAlign="center"
            width="100%"
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={2}
          >
            <Icon as={FaFilePdf} boxSize={12} color="red.500" />
            <Text fontWeight="bold" noOfLines={1}>
              {src?.name}
            </Text>
          </Box>
        ) : (
          <Image
            src={previewUrl}
            alt={type}
            objectFit="fit"
            borderRadius="md"
            width="100%"
            height="100%"
            overflow='hidden'
          />
        )}
      </Dialog.Trigger>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header textAlign="center">
            <Dialog.Title>{label}</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body>
            <HStack height="100%" justifyContent="center" border="0.5px solid">
              {isPdf ? (
                isMobile ? (
                  <Text textAlign="center">
                    PDF preview not supported on this device.{" "}
                    <a
                      href={previewUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue", textDecoration: "underline" }}
                    >
                      Click here to open
                    </a>
                  </Text>
                ) : (
                  <iframe
                    src={previewUrl}
                    title="PDF Preview"
                    width="80%"
                    height="500px"
                    style={{ border: "none" }}
                  />
                )
              ) : (
                <Image
                  src={previewUrl}
                  alt={type}
                  objectFit="fit"
                  borderRadius="md"
                />
              )}
            </HStack>
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
